import { AnyAction, createSlice } from '@reduxjs/toolkit';
import * as actionTypes from './snackBarActionTypes';
import { SnackBarState } from '@greenkub-fronts/shared/interface';

export const SNACKBAR_FEATURE_KEY = 'snackbar';

const snackBarInit = (): SnackBarState => {
  return {
    currentMessageId: 0,
    messages: [],
  };
};

export const initialSnackbarState: SnackBarState = snackBarInit();

export const { reducer: snackbar, actions: snackbarActions } = createSlice({
  name: SNACKBAR_FEATURE_KEY,
  initialState: initialSnackbarState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      actionTypes.ADD_SNACK_MESSAGE,
      (state, action: AnyAction) => {
        state.currentMessageId = action['payload'].currentMessageId;
        state.messages = action['payload'].messages;
      }
    );
    builder.addCase(
      actionTypes.REMOVE_SNACK_MESSAGE,
      (state, action: AnyAction) => {
        state.messages = action['payload'].messages;
      }
    );
  },
});
